import React, { useEffect } from "react";
import ReactPlayer from "react-player";
import "../../../../ui-styles/fileView/FileView.css";
import "../../../../ui-styles/bottomSlider/BottomDetailsSlide.css";

const VideoModal = (props) => {
    useEffect(() => {
        document.body.classList.add('noScroll');
        return () => {
            document.body.classList.remove('noScroll');
        }
    }, [])


    const { current, total, data } = props;
    const handleNext = () => {
        props.handleChange(current + 1);
    }
    const handlePrev = () => {
        props.handleChange(current - 1);
    }

    return (
        <div className={props.data ? "btmDtlSlider visible" : "btmDtlSlider"}>

            <div className="fileViewWrapper">
                {current > 0 && <div className="leftSlideBtn" onClick={handlePrev}></div>}
                {total - 1 > current && <div className="rightSlideBtn" onClick={handleNext}></div>}
                <div className="fvHdrCntnr">
                    <div className="fileViewHeader">
                        <div className="fileTxtRow">
                            <span className="fileHdrTxtL">{data.uploadname}</span>
                        </div>
                    </div>
                    <div className="fileHdrActn" onClick={props.handleClose}></div>
                </div>

                <div className="mediaBdyCntnr">
                    <div className="mediaBdy">
                        <div className="mediaViewBox">
                            <div className="videoIframe">
                                <ReactPlayer
                                    className={
                                        data.url.indexOf(".mp3") > 0 ? "react-player" : ""
                                    }
                                    controls
                                    url={data.url}
                                    width="100%"
                                    height="100%"
                                />
                                {/* <iframe title={`videomodel${current}`}src={data.url} alt="video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VideoModal;